import script from "./FichaEstadistica.vue?vue&type=script&lang=ts&setup=true"
export * from "./FichaEstadistica.vue?vue&type=script&lang=ts&setup=true"

import "./FichaEstadistica.vue?vue&type=style&index=0&id=619d1b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619d1b68"]])

export default __exports__